/**
 * @author Junaid Atari <mj.atari@gmail.com>
 * @see https://github.com/blacksmoke26/dawn-of-man-generator
 * @since 2020-08-29
 */

import {capitalCase} from 'change-case';

export const humanEntities: string[] = [
  'primitive_human',
];

export const animalEntities: string[] = [
  'ancient_bison',
  'aurochs',
  'bear',
  'bison',
  'boar',
  'cattle',
  'cave_bear',
  'cave_hyena',
  'cave_lion',
  'deer',
  'dog',
  'donkey',
  'dove',
  'eagle',
  'elasmotherium',
  'feral_horse',
  'goat',
  'horse',
  'ibex',
  'mammoth',
  'megaloceros',
  'mouflon',
  'muskox',
  'pig',
  'reindeer',
  'sheep',
  'vulture',
  'wild_donkey',
  'wild_horse',
  'wolf',
  'woolly_rhinoceros',
];

export const structureEntities: string[] = [
  'armorer',
  'banner',
  'blacksmith',
  'bloomery',
  'brewery',
  'bridge',
  'burial_mound',
  'cairn',
  'charcoal_pit',
  'copper_mine',
  'crafter',
  'deep_iron_mine',
  'dolmen',
  'flint_mine',
  'food_dryer',
  'gate',
  'granary',
  'guard_tower',
  'haystack',
  'hearth',
  'hut',
  'iron_mine',
  'menhir',
  'metalsmith',
  'mortar',
  'outfitter',
  'oven',
  'palisade',
  'pit_furnace',
  'reinforced_gate',
  'reinforced_platform',
  'rock_pile',
  'roundhouse',
  'skins_dryer',
  'skull_pole',
  'stables',
  'staddle_granary',
  'statue',
  'stone_circle',
  'stone_stables',
  'storage_hut',
  'storage_tent',
  'tanner',
  'tent',
  'tin_mine',
  'totem',
  'transport_post',
  'wall',
  'warehouse',
  'watchtower',
  'watermill',
  'weaver',
  'well',
  'wood_pile',
  'wooden_platform',
  'workshop',
];

export const transportEntities: string[] = [
  'cart',
  'plow',
  'rolling_megalith',
  'sledge',
];

export const resourceEntities: string[] = [
  'beer',
  'berries',
  'biface',
  'bone',
  'bone_harpoon',
  'bone_knife',
  'bone_sickle',
  'bone_spear',
  'bow',
  'bread',
  'bronze',
  'bronze_axe',
  'bronze_knife',
  'bronze_pick',
  'bronze_sickle',
  'bronze_spear',
  'bronze_sword',
  'charcoal',
  'composite_bow',
  'copper',
  'copper_axe',
  'copper_knife',
  'copper_ore',
  'copper_pick',
  'copper_sickle',
  'copper_spear',
  'cured_meat',
  'dry_fish',
  'dry_skin',
  'fish_trap',
  'fishing_rod',
  'flint',
  'flint_axe',
  'flint_knife',
  'flint_pick',
  'flint_sickle',
  'flint_spear',
  'flour',
  'fruit',
  'grain',
  'iron',
  'iron_axe',
  'iron_knife',
  'iron_ore',
  'iron_pick',
  'iron_sickle',
  'iron_spear',
  'iron_sword',
  'leather',
  'leather_armor',
  'leather_outfit',
  'linen',
  'linen_cloth',
  'linen_outfit',
  'log',
  'mail_armor',
  'megalith',
  'milk',
  'mud',
  'nuts',
  'oval_shield',
  'pulses',
  'raw_fish',
  'raw_meat',
  'raw_skin',
  'round_shield',
  'skins_outfit',
  'sling',
  'steel',
  'steel_axe',
  'steel_knife',
  'steel_pick',
  'steel_sickle',
  'steel_spear',
  'steel_sword',
  'sticks',
  'stone',
  'straw',
  'tannin',
  'tin_ore',
  'water',
  'wooden_harpoon',
  'wooden_spear',
  'wool',
  'wool_cloth',
  'wool_outfit',
];

export const techEntities: string[] = [
  'archery',
  'armor',
  'baking',
  'bone_polishing',
  'bone_tools',
  'brewing',
  'bronze_smelting',
  'cattle_domestication',
  'cereal_domestication',
  'complex_megalithism',
  'composite_archery',
  'composite_tools',
  'copper_smelting',
  'deep_mining',
  'dog_domestication',
  'dog_training',
  'donkey_domestication',
  'flax_domestication',
  'food_drying',
  'fortifications',
  'fruit_tree_domestication',
  'funerary_rituals',
  'goat_domestication',
  'grain_processing',
  'horse_domestication',
  'hydropower',
  'iron_smelting',
  'mail',
  'masonry',
  'megalithism',
  'netting',
  'pig_domestication',
  'plowing',
  'pottery',
  'pulse_domestication',
  'pulse_processing',
  'reinforced_fortifications',
  'reinforced_shields',
  'rye_domestication',
  'sheep_domestication',
  'shieldmaking',
  'sledgemaking',
  'slingmaking',
  'spirituality',
  'staddle_stones',
  'steelmaking',
  'stilting',
  'stone_carving',
  'stone_polishing',
  'swordmaking',
  'tanning',
  'thatching',
  'underground_mining',
  'weaving',
  'well_digging',
  'wheel'
];

export const recipeEntities: string[] = [
  'recipe_beer',
  'recipe_biface',
  'recipe_bone_harpoon',
  'recipe_bone_knife',
  'recipe_bone_sickle',
  'recipe_bone_spear',
  'recipe_bow',
  'recipe_bread',
  'recipe_bread_bulk',
  'recipe_bronze',
  'recipe_bronze_axe',
  'recipe_bronze_knife',
  'recipe_bronze_pick',
  'recipe_bronze_sickle',
  'recipe_bronze_spear',
  'recipe_bronze_sword',
  'recipe_charcoal',
  'recipe_composite_bow',
  'recipe_copper',
  'recipe_copper_axe',
  'recipe_copper_knife',
  'recipe_copper_pick',
  'recipe_copper_sickle',
  'recipe_copper_spear',
  'recipe_cured_meat',
  'recipe_dry_fish',
  'recipe_dry_skin',
  'recipe_fish_trap',
  'recipe_fishing_rod',
  'recipe_flint_axe',
  'recipe_flint_knife',
  'recipe_flint_pick',
  'recipe_flint_sickle',
  'recipe_flint_spear',
  'recipe_flour',
  'recipe_flour_bulk',
  'recipe_iron',
  'recipe_iron_axe',
  'recipe_iron_knife',
  'recipe_iron_pick',
  'recipe_iron_sickle',
  'recipe_iron_spear',
  'recipe_iron_sword',
  'recipe_leather',
  'recipe_leather_armor',
  'recipe_leather_outfit',
  'recipe_linen_cloth',
  'recipe_linen_outfit',
  'recipe_mail_armor',
  'recipe_oval_shield',
  'recipe_round_shield',
  'recipe_skins_outfit',
  'recipe_sling',
  'recipe_steel',
  'recipe_steel_axe',
  'recipe_steel_knife',
  'recipe_steel_pick',
  'recipe_steel_sickle',
  'recipe_steel_spear',
  'recipe_steel_sword',
  'recipe_wooden_harpoon',
  'recipe_wooden_spear',
  'recipe_wool_cloth',
  'recipe_wool_outfit',
];

export const ENTITIES = [
  ...humanEntities,
  ...animalEntities,
  ...structureEntities,
  ...transportEntities,
  ...resourceEntities,
  ...techEntities,
  ...recipeEntities,
] as string[];

export const ENTITIES_LIVING = [...humanEntities, ...animalEntities] as const;

export const ENTITIES_LIVING_OPTIONS = [
  {label: 'Human', options: humanEntities.map(value => ({label: capitalCase(value), value, type: 'human'}))},
  {label: 'Animal', options: animalEntities.map(value => ({label: capitalCase(value), value, type: 'animal'}))},
] as const;

export const ENTITIES_OPTIONS = [
  ...ENTITIES_LIVING_OPTIONS,
  {
    label: 'Structure',
    options: structureEntities.map(value => ({label: capitalCase(value), value, type: 'structure'})),
  },
  {
    label: 'Transport',
    options: transportEntities.map(value => ({label: capitalCase(value), value, type: 'transport'})),
  },
  {label: 'Resource', options: resourceEntities.map(value => ({label: capitalCase(value), value, type: 'resource'}))},
  {label: 'Tech', options: techEntities.map(value => ({label: capitalCase(value), value, type: 'tech'}))},
  {
    label: 'Recipe',
    options: recipeEntities.map(value => ({
      label: capitalCase(value.replace('recipe_', '')) + ' (recipe)',
      value,
      type: 'recipe',
    })),
  },
] as const;
